<template>
  <section class="l-guide__title --risk">
    <div class="l-guide__title__inner">
      <p class="l-guide__title__pict">
        <img
          class="l-guide__title__pict__img"
          src="@/assets/img/common/pict-risk.svg"
        />
      </p>
      <h1 class="l-guide__title__heading">個人をとりまくリスクと保険</h1>
    </div>
  </section>
  <RiskNav />
</template>

<script>
import RiskNav from "./components/RiskNav.vue";
export default {
  name: "PageRisk",
  components: {
    RiskNav,
  },
  computed: {},
};
</script>

<style scoped lang="scss">
.v-enter-active,
.v-leave-active {
  transition: opacity 0.5s ease;
}
.v-enter-from,
.v-leave-to {
  opacity: 0;
}
.l-guide {
  &__title {
    height: 80px;
    &.--risk {
      background-color: $color-risk;
    }
    &.--lifestage {
      background-color: $color-lifestage;
    }
    &.--flowchart {
      background-color: $color-flowchart;
    }
    &__inner {
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 10px;
      height: 100%;
      margin: 0 auto;
      @include pc {
        width: $width-contents-pc;
      }
    }
    &__pict {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 60px;
      height: 50px;
      background-color: #fff;
      border-radius: 5px;
    }
    &__heading {
      color: #fff;
      font-weight: 800;
      @include font-size(20px);
      text-align: center;
    }
  }
}
</style>
